import type { ReactNode } from "react";

const PATHS: Record<string, ReactNode> = {
  home: (
    <>
      <path d="M3 12l9-9 9 9" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </>
  ),
  swap: (
    <>
      <path d="M7 7h13l-3-3" />
      <path d="M17 17H4l3 3" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.5-4.5" />
    </>
  ),
  bell: (
    <>
      <path d="M6 8a6 6 0 0112 0v5l2 3H4l2-3V8z" />
      <path d="M10 19a2 2 0 004 0" />
    </>
  ),
  chat: <path d="M21 15a3 3 0 01-3 3H8l-5 4V6a3 3 0 013-3h12a3 3 0 013 3v9z" />,
  store: (
    <>
      <path d="M3 9l1-5h16l1 5" />
      <path d="M3 9v11h18V9" />
      <path d="M9 20v-6h6v6" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0116 0" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  calendar: (
    <>
      <rect x="3" y="4.5" width="18" height="16.5" rx="2" />
      <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  check: <path d="M5 12l5 5L20 7" />,
  x: <path d="M6 6l12 12M18 6l-12 12" />,
  star: <path d="M12 3l2.7 6.3 6.8.6-5.1 4.5 1.5 6.6L12 17.8 6.1 21l1.5-6.6L2.5 9.9l6.8-.6L12 3z" />,
  arrow: <path d="M5 12h14M13 5l7 7-7 7" />,
  arrowL: <path d="M19 12H5M11 5l-7 7 7 7" />,
  heart: <path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0112 6a5.5 5.5 0 019.5 6c-2.5 4.5-9.5 9-9.5 9z" />,
  upload: (
    <>
      <path d="M12 4v12" />
      <path d="M7 9l5-5 5 5" />
      <path d="M5 20h14" />
    </>
  ),
  book: (
    <>
      <path d="M4 4v16h16V4z" />
      <path d="M12 4v16" />
    </>
  ),
  coin: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9 9h4a2 2 0 010 4H9v3" />
    </>
  ),
  flame: <path d="M12 2s4 4 4 8a4 4 0 11-8 0c0-1 .5-2 1-3 0 2 1 3 2 3 0-3 1-5 1-8z" />,
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 00-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 00-2-1.2L14 3h-4l-.5 2.6a7 7 0 00-2 1.2l-2.4-1-2 3.4 2 1.6A7 7 0 005 12c0 .4 0 .8.1 1.2l-2 1.6 2 3.4 2.4-1a7 7 0 002 1.2L10 21h4l.5-2.6a7 7 0 002-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2z" />
    </>
  ),
  money: (
    <>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  gift: (
    <>
      <path d="M3 8h18v4H3z" />
      <path d="M5 12v9h14v-9" />
      <path d="M12 8v13" />
      <path d="M9 8a3 3 0 010-6c2 0 3 3 3 6" />
      <path d="M15 8a3 3 0 000-6c-2 0-3 3-3 6" />
    </>
  ),
  hammer: (
    <>
      <path d="M14 4l-7 7-3 3 4 4 3-3 7-7" />
      <path d="M14 4l4 4-3 3-4-4z" />
    </>
  ),
  sparkle: <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />,
  filter: <path d="M3 5h18l-7 8v6l-4-2v-4z" />,
  send: <path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" />,
  photo: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="11" r="2" />
      <path d="M21 17l-5-5L7 19" />
    </>
  ),
  moon: <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />,
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5" />
    </>
  ),
  trophy: (
    <>
      <path d="M8 4h8v6a4 4 0 01-8 0V4z" />
      <path d="M5 6h-2a3 3 0 003 3" />
      <path d="M19 6h2a3 3 0 01-3 3" />
      <path d="M9 18h6v3H9z" />
      <path d="M10 14v4M14 14v4" />
    </>
  ),
  logout: (
    <>
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
      <path d="M9 21H4V3h5" />
    </>
  ),
};

interface Props {
  name: string;
  size?: number;
}

export function Icon({ name, size = 18 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name] || null}
    </svg>
  );
}
